/*
 * @Author: Michael
 * @Date: 2018-09-18 15:22:08
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-19 10:34:39
 */

import * as types from './types';
import Vue from 'vue';
import { State, IntroItem } from '@/common/interface';
import { Ladder } from '@/common/interface/group_type';

const currentScrollTop = document.documentElement.scrollTop || document.body.scrollTop;

function changeScrollTop(newScrollTop = currentScrollTop + 1) {
  setTimeout(() => {
    window.scrollTo(currentScrollTop, newScrollTop);
    // 滚动到顶部
    // const parent: any = document.querySelector(`#app`);
    // parent.scrollTo({
    //   top: newScrollTop, //需要父元素设置postion(relative、absolute、fixed)
    //   behavior: 'instant'
    // });
  }, 100);
}
const mutations: any = {
  // 再编辑保存奖品列表
  [types.CHANGE_OLD_PRIZE_LIST](state: State, list: Array<object>) {
    state.oldPrizeList = list;
  },
  [types.CHANGE_TOTALTIMES_STATUS](state: State) {
    let { gachaTypeParameter } = state;
    gachaTypeParameter.totalTimesChecked = !gachaTypeParameter.totalTimesChecked;
    gachaTypeParameter.dayTimesChecked = !gachaTypeParameter.dayTimesChecked;
  },
  [types.CHANGE_DAYTIMES_STATUS](state: State) {
    let { gachaTypeParameter } = state;
    gachaTypeParameter.dayTimesChecked = !gachaTypeParameter.dayTimesChecked;
    gachaTypeParameter.totalTimesChecked = !gachaTypeParameter.totalTimesChecked;
  },
  [types.HANDLE_DELETE_PRIZE_IMG](state: State, index: number) {
    let { gachaTypeParameter } = state;
    gachaTypeParameter.prize.proList[index].img = '';
  },
  [types.TOGGLE_GACHA_TYPE](state: State, targetType: string) {
    let gachaTypeParameter = state.gachaTypeParameter;
    gachaTypeParameter.gachaType = targetType;
    state.gachaTypeParameter = gachaTypeParameter;
  },
  [types.TOGGLE_PLAY_TYPE](state: State, targetType: string) {
    let gachaTypeParameter = state.gachaTypeParameter;
    gachaTypeParameter.playType = targetType;
    state.gachaTypeParameter = gachaTypeParameter;
  },
  [types.CHANGE_SUBTRACT_PRIZE_LENGTH](state: State, value: boolean) {
    state.gachaTypeParameter.hasSubtractPrizeLength = value;
  },
  [types.CHANGE_SUBTRACT_LIMITBUYER_NUM](state: State, value: boolean) {
    state.distributeTypeParameter.hasSubtractLimitBuyerNum = value;
  },
  [types.CHANGE_PRIZE_ITEM](state: State, payload: any) {
    let { gachaTypeParameter } = state;
    let item = gachaTypeParameter.prize.proList[payload.index];
    item[payload.name] = payload[payload.name];
    state.gachaTypeParameter.prize.proList.splice(payload.index, 1, item);
  },
  [types.ADD_PRIZE_PICTURE](state: State, item: object) {
    let { gachaTypeParameter } = state;
    gachaTypeParameter.prize.proList.push(item);
    gachaTypeParameter.prize.addNum = gachaTypeParameter.prize.addNum + 1;
  },
  [types.UPDATE_PRIZE_PICTURE_LIST](state: State, list: Array<any>) {
    let { gachaTypeParameter } = state;
    list.map((item, index) => {
      gachaTypeParameter.prize.proList.map((_item: any, _index: number) => {
        if (index == _index) {
          _item.id = item.id;
        }
      });
    });
  },
  [types.HANDLED_ELETEPRIZE_PROLIST_ITEM](state: State, itemIndex: number) {
    let { gachaTypeParameter } = state;
    gachaTypeParameter.prize.proList.splice(itemIndex, 1);
    gachaTypeParameter.prize.addNum = gachaTypeParameter.prize.addNum - 1;
  },
  [types.CHANGE_XCXFLAG](state: State) {
    state.xcxFlag = true;
  },
  [types.CHANGE_ISINVALID](state: State, isInvalid: any) {
    state.isInvalid = isInvalid;
  },
  [types.CHANGE_ISAGAIN](state: State, isAgain: any) {
    state.isAgain = isAgain;
  },
  [types.CHANGE_OPENID](state: State, { openId }: any) {
    state.openId = openId;
  },
  [types.CHANGE_UID](state: State, { uid }: any) {
    state.uid = uid;
  },
  [types.CHANGE_JOIN_INFO](state: State, payload: any) {
    const { name, phone, instId, signupItemConfig = state.signupItemConfig } = payload;
    Object.assign(state, {
      name,
      instId,
      phone,
      signupItemConfig
    });
  },
  [types.CHANGE_SIGNATURE](state: State, { signature }: any) {
    state.signature = signature;
  },
  [types.CHANGE_TITLE](state: State, { title }: any) {
    state.title = title.slice(0, 50);
  },
  [types.CHANGE_DEADLINE](state: State, { deadline }: any) {
    state.deadline = deadline;
  },
  [types.CHANGE_STARTTIME](state: State, { startTime }: any) {
    state.startTime = startTime;
  },
  [types.CHANGE_INSTNAME](state: State, { instName }: any) {
    state.instName = instName;
  },
  [types.CHANGE_INST_ADDRESS](state: State, instAddress: any) {
    state.instAddress = instAddress;
  },
  [types.CHANGE_WECHAT_ONLINE_STATUS](state: State, status: any) {
    state.wechatMiniOnlineStatus = status;
  },
  [types.CHANGE_XMPAY_STATUS](state: State, status: any) {
    state.xmPayRegisterStatusEnum = status;
  },
  // 下载BGM
  [types.GET_BGM_LIST](state: State, { bgmList }: any) {
    state.bgmList = bgmList;
  },

  // 下载自定义BGM
  [types.GET_CUSTOMIZE_BGM_LIST](state: State, { customizeBgmList }: any) {
    state.customizeBgmList = customizeBgmList;
  },

  // 修改选择的BGM
  [types.CHANGE_SELECTED_BGM](state: State, { selectedBGM }: any) {
    state.selectedBGM = selectedBGM;
  },

  // 修改机构电话
  [types.CHANGE_INST_PHONE](state: State, instPhone: string) {
    state.instPhone = instPhone;
  },

  // 是否限制报名人数开关
  [types.SWITCH_LIMIT_NUMBER](state: State, { status }: any) {
    state.isLimited = status;
  },

  // 修改限制的报名人数
  [types.CHANGE_LIMIT_NUMBER](state: State, { number }: any) {
    state.limitNum = number;
  },

  // 是否可以支付开关
  [types.SWITCH_CAN_PAY](state: State, { status }: any) {
    state.canPay = status;
  },

  // 是否开启短信验证
  [types.SWITCH_SMS_VERIFY](state: State, status: boolean) {
    state.hasOpenSMSVerify = status;
  },

  // 是否需要到底价支付
  [types.SWITCH_MUST_MIN_PAY](state: State, mustMinPay: boolean) {
    state.mustMinPay = mustMinPay;
  },

  [types.SWITCH_PONTENTIAL_JOIN](state: State, status: boolean) {
    state.needLimitNormalStu = status;
  },

  // 支付类型
  [types.CHANGE_PAY_TYPE](state: State, { payType }: any) {
    state.payType = payType;
  },

  // 支付金额
  [types.CHANGE_PAY_NUMBER](state: State, { number }: any) {
    state.payNumber = number;
  },

  // 切换是否开启虚拟成团
  [types.CHANGE_VIRTUAL_GROUP](state: State, status: boolean) {
    state.virtualGroup = status;
  },

  /***** 活动说明模块 *****/
  // 修改活动规则
  [types.CHANGE_ACTIVITY_RULE](state: State, { activityRule }: any) {
    state.activityRule = activityRule;
  },
  // 修改标题
  [types.CHANGE_ACTIVITY_TITLE](state: State, status: string) {
    state.activityTitle = status;
  },
  // 修改开关
  [types.CHANGE_ACTIVITY_SWITCH](state: State, status: boolean) {
    state.activitySwitch = status;
  },
  // 修改活动规则某个值
  [types.CHANGE_ACTIVITY_INTROS](state: State, payload: any) {
    state.activityIntros[payload.index].value = payload.value;
  },
  // 添加
  [types.ADD_ACTIVITY_INTROS](state: State, { item }: any) {
    if (item.type == 'video') {
      let index = 0;
      let hasVideo = false;
      (state.activityIntros || []).map((_item: any, _index: number) => {
        if (_item.type == 'video') {
          hasVideo = true;
          index = _index;
        }
      });
      if (hasVideo) {
        state.activityIntros.splice(index, 1, item);
      } else {
        state.activityIntros.push(item);
      }
    } else {
      state.activityIntros.push(item);
    }
  },
  // 删除
  [types.REMOVE_ACTIVITY_INTROS](state: State, index: number) {
    state.activityIntros.splice(index, 1);
  },
  // 上移
  [types.UP_ACTIVITY_INTROS](state: State, index: number) {
    const prevItem: IntroItem = state.activityIntros[index - 1];
    const nextItem: IntroItem = state.activityIntros[index];
    state.activityIntros.splice(index - 1, 2, nextItem, prevItem);
  },
  // 下移
  [types.DOWN_ACTIVITY_INTROS](state: State, index: number) {
    const prevItem: IntroItem = state.activityIntros[index];
    const nextItem: IntroItem = state.activityIntros[index + 1];
    state.activityIntros.splice(index, 2, nextItem, prevItem);
  },
  // 替换
  [types.REPLACE_ACTIVITY_INTROS](state: State, payload: any) {
    state.activityIntros = payload;
  },
  /***** ***** *****/

  // 修改联系方式
  [types.CHANGE_CONTACT_INFO](state: State, { contactInfo }: any) {
    state.contactInfo = contactInfo;
  },
  // 修改联系方式标题
  [types.CHANGE_CONTACT_TITLE](state: State, status: string) {
    state.contactTitle = status;
  },
  // 修改联系方式开关
  [types.CHANGE_CONTACT_SWITCH](state: State, status: boolean) {
    state.contactSwitch = status;
  },

  // 修改机构简介标题
  [types.CHANGE_INSTITUTION_TITLE](state: State, status: string) {
    state.institutionTitle = status;
  },
  // 修改机构简介模块开关
  [types.CHANGE_INSTITUTION_SWITCH](state: State, status: boolean) {
    state.institutionSwitch = status;
  },
  // 修改机构简介
  [types.CHANGE_INSTITUTION_INTROS](state: State, payload: any) {
    state.institutionIntros[payload.index].value = payload.value;
  },
  // 添加一个机构简介
  [types.ADD_INSTITUTION_INTROS](state: State, { item }: any) {
    if (item.type == 'video') {
      let index = 0;
      let hasVideo = false;
      (state.institutionIntros || []).map((_item: any, _index: number) => {
        if (_item.type == 'video') {
          hasVideo = true;
          index = _index;
        }
      });
      if (hasVideo) {
        state.institutionIntros.splice(index, 1, item);
      } else {
        state.institutionIntros.push(item);
      }
    } else {
      state.institutionIntros.push(item);
    }
  },

  //删除一个机构介绍
  [types.REMOVE_INSTITUTION_INTROS](state: State, index: number) {
    state.institutionIntros.splice(index, 1);
  },

  // 上移一个机构简介
  [types.UP_INSTITUTION_INTROS](state: State, index: number) {
    const prevItem: IntroItem = state.institutionIntros[index - 1];
    const nextItem: IntroItem = state.institutionIntros[index];
    state.institutionIntros.splice(index - 1, 2, nextItem, prevItem);
  },

  // 下移一个机构简介
  [types.DOWN_INSTITUTION_INTROS](state: State, index: number) {
    const prevItem: IntroItem = state.institutionIntros[index];
    const nextItem: IntroItem = state.institutionIntros[index + 1];
    state.institutionIntros.splice(index, 2, nextItem, prevItem);
  },

  // 添加一个课程
  [types.ADD_COURSE_DESC](state: State, { item }: any) {
    if (item.type == 'video') {
      let index = 0;
      let hasVideo = false;
      (state.distributeTypeParameter.courseDesc || []).map((_item: any, _index: number) => {
        if (_item.type == 'video') {
          hasVideo = true;
          index = _index;
        }
      });
      if (hasVideo) {
        state.distributeTypeParameter.courseDesc.splice(index, 1, item);
      } else {
        state.distributeTypeParameter.courseDesc.push(item);
      }
    } else {
      state.distributeTypeParameter.courseDesc.push(item);
    }
  },

  // 修改课程描述
  [types.CHANGE_COURSE_DESC](state: State, payload: any) {
    state.distributeTypeParameter.courseDesc[payload.index].value = payload.value;
  },

  //删除一个课程
  [types.REMOVE_COURSE_DESC](state: State, index: number) {
    state.distributeTypeParameter.courseDesc.splice(index, 1);
  },

  // 上移一个机构简介
  [types.UP_COURSE_DESC](state: State, index: number) {
    const prevItem: IntroItem = state.distributeTypeParameter.courseDesc[index - 1];
    const nextItem: IntroItem = state.distributeTypeParameter.courseDesc[index];
    state.distributeTypeParameter.courseDesc.splice(index - 1, 2, nextItem, prevItem);
  },

  // 下移一个机构简介
  [types.DOWN_COURSE_DESC](state: State, index: number) {
    const prevItem: IntroItem = state.distributeTypeParameter.courseDesc[index];
    const nextItem: IntroItem = state.distributeTypeParameter.courseDesc[index + 1];
    state.distributeTypeParameter.courseDesc.splice(index, 2, nextItem, prevItem);
  },

  // 获取配置信息
  [types.UPDATE_CONFIG_STATE](state: State, payload: any) {
    Object.assign(state, payload.config);
    document.title = payload.config.documentTitle;
    changeScrollTop(0);
  },

  // 获取活动数据
  [types.UPDATE_DETAIL_DATA](state: State, payload: any) {
    Object.assign(state, payload.remoteData, payload.content, payload.parameter);
  },

  // 获取活动数据
  [types.UPDATE_GACHATYPE_PARAMETER](state: State, payload: any) {
    Object.assign(state, payload.gachaTypeParameter);
  },

  // 修改分享图标
  [types.CHANGE_COVER_TINY](state: State, shareCover: string) {
    state.coverTiny = shareCover;
  },

  // 修改保存活动后活动限制人数开关的flag，再编辑时会用到
  [types.CHANGE_LIMIT_FLAG](state: State, limitFlag: boolean) {
    state.limitFlag = limitFlag;
  },
  [types.CHANGE_LIMIT_FLAG_NUMBER](state: State, limitFlagNumber: number) {
    state.limitFlagNumber = limitFlagNumber;
  },

  // 修改参加人数
  [types.CHANGE_RELEASE_STATUS](state: State, joinNumber: string) {
    state.joinNumber = joinNumber;
  },

  // 修改发布状态
  [types.CHANGE_JOIN_NUMBER](state: State, releaseStatus: string) {
    state.releaseStatus = releaseStatus;
  },
  // 修改查看人数
  [types.CHANGE_SCAN_NUMBER](state: State, scanNumber: string) {
    state.scanNumber = scanNumber;
  },
  //查看版本
  [types.CHANGE_EXT_ID](state: State, showExtId: string) {
    state.showExtId = showExtId;
  },
  // 修改是否收款类型
  [types.CHANGE_SUPPORT_PAY](state: State, supportPay: boolean) {
    console.log(supportPay, 'supportPay');
    state.supportPay = supportPay;
  },
  // 修改支付通道
  [types.CHANGE_XM_PAY](state: State, channel: string) {
    state.channel = channel;
  },
  // 修改是否收款类型
  [types.CHANGE_SUPPORT_PAY](state: State, supportPay: boolean) {
    console.log(supportPay, 'supportPay');
    state.supportPay = supportPay;
  },
  // 修改支付通道
  [types.CHANGE_XM_PAY](state: State, channel: string) {
    state.channel = channel;
  },
  // 修改分销参数
  [types.CHANGE_DISTRIBUTE_PARAMETER](state: State, payload: any) {
    state.distributeTypeParameter = { ...state.distributeTypeParameter, ...payload };
  },
  // 修改扭蛋机参数
  [types.CHANGE_GACHA_PARAMETER](state: State, payload: any) {
    state.gachaTypeParameter = { ...state.gachaTypeParameter, ...payload };
  },
  // 修改砍价参数
  [types.CHANGE_BARGAIN_PARAMETER](state: State, payload: any) {
    state.bargainParameter = { ...state.bargainParameter, ...payload };
  },

  // 修改集赞参数
  [types.CHANGE_TYTYPE_PARAMETER](state: State, payload: any) {
    Object.assign(state.tyTypeParameter, payload);
  },

  // 修改section里的信息
  [types.CHANGE_SECTION_INFO](state: State, payload: any) {
    (state.section as any)[payload.type] = payload.value;
  },

  /********** 修改section的prizeIntro **********/
  // 改变
  [types.CHANGE_PRIZE_INTROS](state: State, payload: any) {
    state.section.prizeIntros[payload.index].value = payload.value;
  },
  // 添加
  [types.ADD_PRIZE_INTROS](state: State, { item }: any) {
    if (item.type == 'video') {
      let index = 0;
      let hasVideo = false;
      (state.section.prizeIntros || []).map((_item: any, _index: number) => {
        if (_item.type == 'video') {
          hasVideo = true;
          index = _index;
        }
      });
      if (hasVideo) {
        state.section.prizeIntros.splice(index, 1, item);
      } else {
        state.section.prizeIntros.push(item);
      }
    } else {
      state.section.prizeIntros.push(item);
    }
  },
  // 删除
  [types.REMOVE_PRIZE_INTROS](state: State, index: number) {
    state.section.prizeIntros.splice(index, 1);
  },
  // 上移
  [types.UP_PRIZE_INTROS](state: State, index: number) {
    const prevItem: IntroItem = state.section.prizeIntros[index - 1];
    const nextItem: IntroItem = state.section.prizeIntros[index];
    state.section.prizeIntros.splice(index - 1, 2, nextItem, prevItem);
  },
  // 下移
  [types.DOWN_PRIZE_INTROS](state: State, index: number) {
    const prevItem: IntroItem = state.section.prizeIntros[index];
    const nextItem: IntroItem = state.section.prizeIntros[index + 1];
    state.section.prizeIntros.splice(index, 2, nextItem, prevItem);
  },
  /********** ********** **********/

  /********** 修改section的courseIntros **********/
  // 改变
  [types.CHANGE_COURSE_INTROS](state: State, payload: any) {
    state.section.courseIntros[payload.index].value = payload.value;
  },
  // 添加
  [types.ADD_COURSE_INTROS](state: State, { item }: any) {
    if (item.type == 'video') {
      let index = 0;
      let hasVideo = false;
      (state.section.courseIntros || []).map((_item: any, _index: number) => {
        if (_item.type == 'video') {
          hasVideo = true;
          index = _index;
        }
      });
      if (hasVideo) {
        state.section.courseIntros.splice(index, 1, item);
      } else {
        state.section.courseIntros.push(item);
      }
    } else {
      state.section.courseIntros.push(item);
    }
  },
  // 删除
  [types.REMOVE_COURSE_INTROS](state: State, index: number) {
    state.section.courseIntros.splice(index, 1);
  },
  // 上移
  [types.UP_COURSE_INTROS](state: State, index: number) {
    const prevItem: IntroItem = state.section.courseIntros[index - 1];
    const nextItem: IntroItem = state.section.courseIntros[index];
    state.section.courseIntros.splice(index - 1, 2, nextItem, prevItem);
  },
  // 下移
  [types.DOWN_COURSE_INTROS](state: State, index: number) {
    const prevItem: IntroItem = state.section.courseIntros[index];
    const nextItem: IntroItem = state.section.courseIntros[index + 1];
    state.section.courseIntros.splice(index, 2, nextItem, prevItem);
  },
  /********** ********** **********/

  // 修改选择等级
  [types.CHANGE_CHOOSE_DEGREE](state: State, chooseDegree: any) {
    state.chooseDegree = chooseDegree;
  },

  // 修改排行榜
  [types.CHANGE_RANK_LIST](state: State, rankList: Array<any>) {
    state.rankList = rankList;
  },
  // 修改地址上的uid
  [types.CHANGE_URL_UID](state: State, uid: string) {
    console.log('urlUid', uid);
    state.urlUid = uid;
  },

  // 修改概率
  [types.CHANGE_CHANCE_COUNT](state: State, payload: any) {
    state.chance = payload.chance;
    state.count = payload.count;
  },

  // 修改未成团列表开关
  [types.CHANGE_UNGROUP_SWITCH](state: State, status: boolean) {
    state.unGroupSwitch = status;
  },
  // 拼团失败自动取消报名
  [types.CHANGE_AUTO_CANCEL](state: State, status: boolean) {
    state.autoCancel = status;
  },

  // 修改老生开关
  [types.CHANGE_GROUP_SWITCH](state: State, status: boolean) {
    state.groupSwitch = status;
  },

  // 修改上传的活动主图
  [types.CHANGE_GROUP_IMAGE_LIST](state: State, payload: any) {
    if (payload.value) {
      // 如果传了value,则把当前字段置为0
      Vue.set(state.groupImageList, payload.index, payload.value);
    } else {
      // 如果不传，则删掉这个节点，在最后加一个节点
      const groupImageList = state.groupImageList;
      groupImageList.splice(payload.index, 1);
      groupImageList.push('');
      state.groupImageList = groupImageList;
    }
  },

  // 修改拼团列表
  [types.CHANGE_GROUP_LIST](state: State, groupList: Array<object>) {
    state.groupList = groupList;
  },

  // 修改开团成团数
  [types.CHANGE_GROUP_NUMBER](state: State, payload: any) {
    state.groupCreateNumber = payload.groupCreateNumber;
    state.groupCompleteNumber = payload.groupCompleteNumber;
    state.groupFullNumber = payload.groupFullNumber;
  },

  // 修改团是否满的参数
  [types.CHANGE_GROUP_FULL](state: State, status: boolean) {
    state.groupFull = status;
  },

  [types.CHANGE_SHOW_FOOTER](state: State, status: boolean) {
    state.showFooter = status;
  },

  // 修改是否已支付状态
  [types.CHANGE_HAS_PAY](state: State, status: number) {
    state.hasPay = status;
  },
  [types.CHANGE_CANNEL](state: State, status: boolean) {
    state.cancel = status;
  },
  [types.HAS_SIGN_IN](state: State, status: boolean) {
    state.hasSignIn = status;
  },

  [types.CHANGE_SHOW_JOIN_FOOTER](state: State, status: boolean) {
    state.showJoinFooter = status;
  },

  [types.CHANGE_JOIN_GROUP_FLAG](state: State, status: boolean) {
    state.joinGroupFlag = status;
  },

  [types.CHANGE_ORIGINAL_TITLE](state: State, status: string) {
    state.originalTitle = status;
  },

  // 修改网页标题
  [types.CHANGE_DOCUMENT_TITLE](state: State, status: string) {
    state.documentTitle = status;
    document.title = status;
  },

  // 修改活动主题
  [types.CHANGE_VIEW_BACKGROUND](state: State, status: string) {
    state.viewBackground = status;
  },

  // 修改二维码图片
  [types.CHANGE_CONTACT_QRCODE](state: State, status: string) {
    state.contactQrcode = status;
  },

  // 修改报名信息设置
  [types.CHANGE_SIGNUP_ITEM_CONFIG](state: State, status: string) {
    state.signupItemConfig = status;
  },
  // 修改报名信息设置
  [types.CHANGE_USERAWARD_InfO](state: State, status: any) {
    state.userAwardInfo = status;
  },
  // 是否开启弹幕信息
  [types.CHANGE_SHOW_BARRAGE](state: State, status: boolean) {
    state.showBarrage = status;
  },
  // 是否开启相应数据展示
  [types.CHANGE_SHOW_NUM](state: State, status: boolean) {
    state.showNum = status;
  },
  // 是否开启统计数据展示
  [types.CHANGE_SHOW_DATA](state: State, status: boolean) {
    state.showData = status;
  },

  // 是否购买小麦管家
  [types.CHANGE_BUY_XMMAJORDOMO](state: State, status: boolean) {
    state.xmMajordomo = status;
  },

  // 修改海报名称
  [types.CHANGE_POSTER_NAME](state: State, name: string) {
    state.posterName = name;
  },

  [types.CHANGE_POSTER_AVATAR](state: State, avatar: string) {
    state.posterAvatar = avatar;
  },

  [types.CHANGE_POSTER_URL](state: State, url: string) {
    state.posterUrl = url;
  },

  [types.CHANGE_SHOW_IWANT_DO](state: State, status: boolean) {
    // 是否显示我也要招生
    state.showWantDo = status;
  },

  // 修改阶梯拼团方案
  [types.CHANGE_LADDER_GROUP](state: State, ladderGroupList: Array<Ladder>) {
    state.ladderGroupList = ladderGroupList;
  },
  // 修改团长奖励
  [types.CHANGE_HEAD_REWARD](state: State, headReward: string) {
    state.headReward = headReward;
  },

  [types.CHANGE_LEFTQUOTA](state: State, leftQuota: number) {
    state.leftQuota = leftQuota;
  },

  [types.CHANGE_SOLITAIREING_LIST](state: State, solitareingList: Array<object>) {
    state.solitareingList = solitareingList;
  },
  [types.CHANGE_HASPAID_NUMBER](state: State, hasPaidNumber: number) {
    state.hasPaidNumber = hasPaidNumber;
  },
  [types.CHANGE_MATERIAL_STATUA](state: State, status: boolean) {
    state.hasMaterialSaved = status;
  },
  [types.CHANGE_INSTSMS_VERIFY](state: State, status: boolean) {
    state.hasInstOpenSMSVerify = status;
  },
  [types.CHANGE_SMS_REMAIN_NUMBER](state: State, smsRemainNumber: number) {
    state.smsRemainNumber = smsRemainNumber;
  },
  [types.CHANGE_PAY_EDIT_MODAL](state: State, showPayEditModal: boolean) {
    state.showPayEditModal = showPayEditModal;
  },
  [types.CHANGE_INVALID_MODAL](state: State, showInValidModal: boolean) {
    state.showInValidModal = showInValidModal;
  },
  [types.CHANGE_SELECTED_CARD_INDEX](state: State, selectedCardIndex: number) {
    state.selectedCardIndex = selectedCardIndex;
  },
  [types.CHANGE_GACHA_LOADING](state: State, gachaLoading: boolean) {
    state.gachaLoading = gachaLoading;
  },
  [types.CHANGE_GACHA_START](state: State, gachaStart: boolean) {
    state.gachaStart = gachaStart;
  },
  [types.CHANGE_DETAIL_LOADED](state: State, detailLoaded: boolean) {
    state.detailLoaded = detailLoaded;
  },
  [types.CHANGE_SHOW_WESITEBTN](state: State, showWesiteBtn: boolean) {
    state.showWesiteBtn = showWesiteBtn;
  },
  [types.CHANGE_AVATAR](state: State, avatar: string) {
    state.avatar = avatar;
  },
  [types.CHANGE_NICKNAME](state: State, nickname: string) {
    state.nickname = nickname;
  },
  [types.CHANGE_DISTRIBUTE_ORDER_CREATETIME](state: State, distributeOrderCreateTime: number) {
    state.distributeOrderCreateTime = distributeOrderCreateTime;
  },
  [types.CHANGE_MY_REWARD](state: State, myReward: number) {
    state.myReward = myReward;
  },
  [types.CHANGE_DISTRIBUTE_PURCHASE_LIST](state: State, distributePurchaseList: Array<object>) {
    state.distributePurchaseList = distributePurchaseList;
  },
  [types.CHANGE_DISTRIBUTE_TRADE_ID](state: State, distributeTradeId: string) {
    state.distributeTradeId = distributeTradeId;
  },
  [types.CHANGE_DISTRIBUTE_TAB_FIXED](state: State, distributeTabFixed: boolean) {
    state.distributeTabFixed = distributeTabFixed;
  },
  [types.CHANGE_INST_IDS](state: State, instIds: Array<string>) {
    state.instIds = instIds;
  },
  [types.CHANGE_INST_LIST](state: State, instList: Array<object>) {
    state.instList = instList;
  },
  [types.CHANGE_INST_NAME_NOT](state: State, instNameNot: Array<string>) {
    state.instNameNot = instNameNot;
  },
  [types.CHANGE_INST_NAME_FEW](state: State, instNameFew: Array<string>) {
    state.instNameFew = instNameFew;
  },
  [types.CHANGE_INST_NAME_ZERO](state: State, instNameZero: Array<string>) {
    state.instNameZero = instNameZero;
  },
  [types.CHANGE_LEADERS_INST_ID](state: State, leadersInstId: string) {
    state.leadersInstId = leadersInstId;
  },
  [types.CHANGE_PAY_INST_ID](state: State, payInstId: string) {
    state.payInstId = payInstId;
  },

  /********** 多课程相关 **********/
  // 改变课程类型
  [types.CHANGE_COURSE_TYPE](state: State, status: string) {
    if (status === 'ONE') {
      state.section.courseGroupList.splice(1);
    }
    state.section.courseType = status;
  },
  // 多课程-添加
  [types.ADD_COURSE_GROUP_INTROS](state: State, { item, seqNo }: any) {
    if (item.type == 'video') {
      let index = 0;
      let hasVideo = false;
      (state.section.courseGroupList[seqNo - 1].courseIntros || []).map((_item: any, _index: number) => {
        if (_item.type == 'video') {
          hasVideo = true;
          index = _index;
        }
      });
      if (hasVideo) {
        state.section.courseGroupList[seqNo - 1].courseIntros.splice(index, 1, item);
      } else {
        state.section.courseGroupList[seqNo - 1].courseIntros.push(item);
      }
    } else {
      state.section.courseGroupList[seqNo - 1].courseIntros.push(item);
    }
  },
  // 上移
  [types.UP_COURSE_GROUP_INTROS](state: State, { index, seqNo }: any) {
    const prevItem: IntroItem = state.section.courseGroupList[seqNo - 1].courseIntros[index - 1];
    const nextItem: IntroItem = state.section.courseGroupList[seqNo - 1].courseIntros[index];
    state.section.courseGroupList[seqNo - 1].courseIntros.splice(index - 1, 2, nextItem, prevItem);
  },
  // 下移
  [types.DOWN_COURSE_GROUP_INTROS](state: State, { index, seqNo }: any) {
    const prevItem: IntroItem = state.section.courseGroupList[seqNo - 1].courseIntros[index];
    const nextItem: IntroItem = state.section.courseGroupList[seqNo - 1].courseIntros[index + 1];
    state.section.courseGroupList[seqNo - 1].courseIntros.splice(index, 2, nextItem, prevItem);
  },
  // 删除
  [types.REMOVE_COURSE_GROUP_INTROS](state: State, { index, seqNo }: any) {
    state.section.courseGroupList[seqNo - 1].courseIntros.splice(index, 1);
  },
  // 改变
  [types.CHANGE_COURSE_GROUP_INTROS](state: State, payload: any) {
    state.section.courseGroupList[payload.seqNo - 1].courseIntros[payload.index].value = payload.value;
  },
  // 修改阶梯拼团方案
  [types.CHANGE_COURSE_GROUP_LADDER](state: State, { value, seqNo }: any) {
    state.section.courseGroupList[seqNo - 1].ladderGroupList = value;
  },
  // 修改阶梯拼团方案
  [types.CHANGE_COURSE_GROUP_ORIGINPRICE](state: State, { value, seqNo }: any) {
    state.section.courseGroupList[seqNo - 1].originPrice = value;
  },
  // 修改选中课程
  [types.CHANGE_SELECTED_SEQNO](state: State, payload: any) {
    state.section.selectedSeqNo = payload;
  },
  // 改变超级团购-分销类型
  [types.CHANGE_DISTRIBUTE_GROUP_MODE](state: State, status: string) {
    state.section.distributeGroupMode = status;
  },
  // 改变超级团购
  [types.CHANGE_COURSE_GROUP_FIRSTREWARD](state: State, { value, seqNo }: any) {
    state.section.courseGroupList[seqNo - 1].firstReward = value;
  },
  [types.CHANGE_COURSE_GROUP_SECONDREWARD](state: State, { value, seqNo }: any) {
    state.section.courseGroupList[seqNo - 1].secondReward = value;
  },
  [types.CHANGE_COURSE_GROUP_HASOPENSECOND](state: State, { value, seqNo }: any) {
    state.section.courseGroupList[seqNo - 1].hasOpenSecondDistribute = value;
  },
  [types.CHANGE_DISTRIBUTE_CHECK_AGREEMENT](state: State, status: boolean) {
    state.section.hasCheckUserAgreement = status;
  },

  /********** ********** **********/
};

export default mutations;
